import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { changeMyPassword, deleteMyAccount, getMyProfile, updateMyProfile } from '@/api/profile.api';

export const PROFILE_QUERY_KEY = ['profile', 'me'] as const;

export function useProfile() {
  return useQuery({
    queryKey: PROFILE_QUERY_KEY,
    queryFn: getMyProfile,
  });
}

/** Saves edits to the individual account (FR-09) and refreshes the cached profile. */
export interface UpdateProfileOptions {
  /** Runs after the cache is updated - the Personal details panel closes and toasts here. */
  onSaved?: () => void;
}

export function useUpdateProfile(options: UpdateProfileOptions = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMyProfile,
    onSuccess: (data) => {
      queryClient.setQueryData(PROFILE_QUERY_KEY, data);
      options.onSaved?.();
    },
  });
}

/** Changes the current user's password. No cached data to update - just an action. */
export function useChangePassword() {
  return useMutation({ mutationFn: changeMyPassword });
}

/** Deletes (soft-deletes) the current user's account. Callers log the user out on success. */
export function useDeleteAccount() {
  return useMutation({ mutationFn: deleteMyAccount });
}
